import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
 
const AllManager = {
}

const calls = {
}

const Register = () => {

    const [issueDate, setIssueDate] = useState(null);
    const [technicalControlExpDate, setTechnicalControlExpDate] = useState(null)

    const handleChangeManager = (value) => {
    }

    const handleManagerID = (value) => {
    }

    const handleManagerIDSubmit = (value) => {
    }

    const [orgAddressDes, setOrgAddressDes] = useState({
        provinceId: "",
        cityId: "",
        terminalId: ""
    })


    const handleChangeProvinceDes = (value) => {
        setOrgAddressDes(prevState => ({ ...prevState, terminalId: "" }))
        setOrgAddressDes(prevState => ({ ...prevState, cityId: "" }))
        setOrgAddressDes(prevState => ({ ...prevState, provinceId: value }))
    }
    const handleChangeCityDes = (value) => {
        setOrgAddressDes(prevState => ({ ...prevState, terminalId: "" }))
        setOrgAddressDes(prevState => ({ ...prevState, cityId: value }))
    }
    const handleChangeTerminalIdDes = (value) => {
        setOrgAddressDes(prevState => ({ ...prevState, terminalId: value }))
    }

    function handleSearchPath(id) { }

    return (
        <form>


            <div class="page-header my-0">
                <h1 class="page-title">سرویس کاربران </h1>
            </div>


            <div class="card">

                <div class="card-header d-flex justify-content-between">
                    <h3 class="card-title">
                        <i className='fa fa-search px-1'></i>
                        جستجوی دوره</h3>

                    <div>
                        <a
                            className="btn btn-purple text-white px-1 py-1 mx-2 collapsBtn_"
                            type="button"
                            title='فیلدها'
                            data-bs-toggle="collapse"
                            href="#collapseExample"
                            role="button"
                            aria-expanded="false"
                            aria-controls="collapseExample"
                            onClick={(value) => handleManagerID(value)}
                        >

                        </a>
                    </div>

          
                </div>


                <div className="row mx-0 my-4 collapse show" id="collapseExample" >

                    <div className="col-md-3">
                        <label className="mb-0">
                            گروه
                        </label>
                        <ReactSelect label="استان"
                            options={AllManager}
                            value={orgAddressDes.provinceId}
                            onChange={handleChangeProvinceDes}
                            placeholder="انتخاب کنید ..."
                            name="sourceProvinceID"
                        />
                    </div>

                    <div className="col-md-3">
                        <label className="mb-0">
                            خدمت
                        </label>
                        <ReactSelect label="شهر"
                            options={AllManager}
                            placeholder="انتخاب کنید ..."
                            name="sourceCityID"
                            value={orgAddressDes.cityId}
                            onChange={handleChangeCityDes}
                        />
                    </div>

                    <div className="col-md-3">
                        <label className="mb-0">
                            زیرخدمت
                        </label>
                        <ReactSelect label="ترمینال"
                            options={AllManager}
                            name="sourceTerminalId"
                            placeholder="انتخاب کنید ..."
                            value={orgAddressDes.terminalId}
                            onChange={handleChangeTerminalIdDes}
                        />
                    </div>

                    <div className="col-md-2 text-left p-0 mt-4 mx-4">
                        <button
                            className="btn btn-outline-info mt-1"
                            type="button"
                            variant="danger"
                            onClick={() => handleSearchPath()}
                        >
                            نمایش دوره
                        </button>
                    </div>

                    <div className='row mx-0 my-4 pt-4'>
                        <div class="table-responsive">
                            <table class="table table-hover border text-nowrap text-md-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th width="1%" className='text-center' >ردیف</th>
                                        <th> گروه </th>
                                        <th> خدمت  </th>
                                        <th> زیر خدمت  </th>
                                        <th width="50%"> عملیات </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='text-center'>1</td>
                                        <td> کاربر 1 </td>
                                        <td> کاربر 1 </td>
                                        <td> کاربر 1 </td>
                                        <td>
                                            <button type="button" class="btn btn-icon  btn-secondary  py-1"> انتخاب</button>

                                            <a
                                                className="btn btn-purple text-white px-3 py-1 mx-2"
                                                type="button"
                                                title='فیلدها'
                                                data-bs-toggle="collapse"
                                                href="#collapseExample02"
                                                role="button"
                                                aria-expanded="false"
                                                aria-controls="collapseExample"
                                                onClick={(value) => handleManagerID(value)}
                                            >
                                                جزئیات
                                            </a>
                                            <div className="collapse " id="collapseExample02" style={{ flex: ".75", margin: "10px 15px 0" }}>
                                                <div className="card card-body bg-lightGray">
                                                    <form>
                                                        <div class="card-header mx-0 px-0 mt-0 pt-0">
                                                            <h3 class="card-title">
                                                                <i className='fa fa-list px-1'></i>
                                                                لیست کاربران </h3>
                                                        </div>
                                                        <div>
                                                            <div class="card-status card-status-right bg-red br-bs-7 br-ts-7"  ></div>
                                                            <table width="100%">
                                                                <tr>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>    کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>   کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>   کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>    کاربر 1
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>    کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>   کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>   کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>    کاربر 1
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>    کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>   کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>   کاربر 1
                                                                    </td>
                                                                    <td width="25%">
                                                                        <i className="fa fa-chevron-left small" style={{ fontSize: "8px" }}></i>    کاربر 1
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-center'>2</td>
                                        <td> کاربر 1 </td>
                                        <td> کاربر 2 </td>
                                        <td> کاربر 1 </td>
                                        <td>
                                            <button type="button" class="btn btn-icon  btn-secondary  py-1">انتخاب</button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-center'>3</td>
                                        <td> کاربر 1 </td>
                                        <td> کاربر 3 </td>
                                        <td> کاربر 1 </td>
                                        <td>
                                            <button type="button" class="btn btn-icon  btn-secondary  py-1">انتخاب</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
            </div>



            <div class="card">
                <div class="card-header d-flex justify-content-between">
                    <h3 class="card-title">
                        <i className='fa fa-search px-1'></i>
                        جستجوی کاربر</h3>
                    <div>
                        <a
                            className="btn btn-purple text-white px-1 py-1 mx-2 collapsBtn_"
                            type="button"
                            title='فیلدها'
                            data-bs-toggle="collapse"
                            href="#collapseExample2"
                            role="button"
                            aria-expanded="false"
                            aria-controls="collapseExample"
                            onClick={(value) => handleManagerID(value)}                        >

                        </a>
                    </div>
                </div>
                <div className="row mx-0 collapse show mt-3" id="collapseExample2">
                    <div className="row mx-0">
                        <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                            <div className="form-group">
                                <label htmlFor="expireDate">   کد ملی   </label>
                                <input label=" title " type="text" name="title"
                                    className="form-control d-flex align-items-center ml-2 mt-0" />
                            </div>
                        </div>
                        <div className="col-md-2 text-left p-0 mt-4 mx-4">
                            <button
                                className="btn btn-outline-info mt-3"
                                type="button"
                                variant="danger"
                                onClick={() => handleSearchPath()}
                            >
                                جستجو
                            </button>
                        </div>
                    </div>


                    <div className="row mx-0">
                        <form>
                            <div>
                                <div className="row mt-4">

                                    <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group">
                                            <label htmlFor="expireDate"> نام  </label>
                                            <input label="نام" name="firstName" className="form-control d-flex align-items-center specialTravel_ ml-2 mt-0" />
                                        </div>
                                    </div>

                                    <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group">
                                            <label htmlFor="expireDate"> نام خانوادگی </label>
                                            <input label="نام خانوادگی" name="lastName" className="form-control d-flex align-items-center specialTravel_ ml-2 mt-0" />
                                        </div>
                                    </div>

                                    <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group">
                                            <label htmlFor="expireDate">   کد ملی    </label>
                                            <input label="کد ملی" name="nationalNoManager" className="form-control d-flex align-items-center specialTravel_ ml-2 mt-0" />
                                        </div>
                                    </div>

                                    <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group">
                                            <label htmlFor="expireDate">    شماره تلفن      </label>
                                            <input label="نام  " name="fatherName" className="form-control d-flex align-items-center specialTravel_ ml-2 mt-0" />
                                        </div>
                                    </div>

                                </div>

                                <div className="row">

                                    <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group">
                                            <label htmlFor="expireDate">   شماره همراه      </label>
                                            <input label="شماره همراه" name="mobileNumber" className="form-control d-flex align-items-center specialTravel_ ml-2 mt-0" />
                                        </div>
                                    </div>
                                    <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group">
                                            <label htmlFor="expireDate">   ایمیل        </label>
                                            <input label="شماره همراه" name="mobileNumber" className="form-control d-flex align-items-center specialTravel_ ml-2 mt-0" />
                                        </div>
                                    </div>

                                    <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group">
                                            <label>   سرویس </label>
                                            <ReactSelect
                                                placeholder="انتخاب کنید"
                                                options={AllManager}
                                                isSearchable={true}
                                                isRtl={true}
                                                onChange={(value) => handleChangeManager(value)}
                                                noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group ">
                                            <label>   فعال ؟ </label>
                                            <input name="hasSpecialServices" type="checkbox"
                                                className="d-flex align-items-center specialTravel_"
                                            />
                                        </div>
                                    </div>



                                </div>

                                <div className="row">

                   {/*                  <div className='col-md-3'>
                                        <div className="form-group">
                                            <label htmlFor="issueDate"> تاریخ ثبت نام   </label><br />
                                            <DatePicker
                                                name="issueDate"
                                                required
                                                locale="fa"
                                                shouldHighlightWeekends
                                                value={issueDate}
                                                onChange={setIssueDate}
                                                inputPlaceholder=' '
                                                calendarPopperPosition={"bottom"}
                                            />
                                        </div>
                                    </div> */}
                                </div>

                                <div className="col-md-4 my-4 mx-auto px-0 text-center">
                                    <button className="btn btn-outline-success mx-auto my-4 px-4">
                                        ثبت
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>


            {/* 
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">
                        <i className='fa fa-list px-1'></i>
                        لیست کاربر ها </h3>
                </div>
                <div class="card-body">

                    <div class="table-responsive">
                        <table class="table table-hover border text-nowrap text-md-nowrap table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th width="1%" className='text-center' >ردیف</th>
                                    <th>     تاریخ ثبت نام  </th>
                                    <th> کاربر  </th>
                                    <th>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='text-center'>1</td>
                                    <td>  -</td>
                                    <td> کاربر 1 </td>
                                    <td>
                                        <button type="button" class="btn btn-icon  btn-danger px-0 py-1 mx-2"><i class="fe fe-trash"></i></button>
                                        <button type="button" class="btn btn-icon  btn-secondary px-0 py-1"><i class="fe fe-edit"></i></button>                                    </td>
                                </tr>

                                <tr>
                                    <td className='text-center'>2</td>
                                    <td>    -</td>
                                    <td> کاربر 2 </td>
                                    <td>
                                        <button type="button" class="btn btn-icon  btn-danger px-0 py-1 mx-2"><i class="fe fe-trash"></i></button>
                                        <button type="button" class="btn btn-icon  btn-secondary px-0 py-1"><i class="fe fe-edit"></i></button>                                    </td>

                                </tr>
                                <tr>
                                    <td className='text-center'>3</td>
                                    <td> -</td>
                                    <td> کاربر 3 </td>
                                    <td>
                                        <button type="button" class="btn btn-icon  btn-danger px-0 py-1 mx-2"><i class="fe fe-trash"></i></button>
                                        <button type="button" class="btn btn-icon  btn-secondary px-0 py-1"><i class="fe fe-edit"></i></button>                                    </td>

                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <ul class="pagination mt-4">
                        <li class="page-item page-prev">
                            <a class="page-link" href="javascript:void(0)" tabindex="-1">قبلی</a>
                        </li>
                        <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                        <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                        <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                        <li class="page-item"><a class="page-link" href="javascript:void(0)">4</a></li>
                        <li class="page-item page-next">
                            <a class="page-link" href="javascript:void(0)">بعدی</a>
                        </li>
                    </ul>


                </div>
            </div >
 */}

        </form >
    )

}

export default Register;    